import { Injectable, inject } from '@angular/core';
import {GenericItems} from '../../../../shared/interfaces/generic-items.interface';
import {LorenUserSettingsEndpointsService} from '../loren-user-settings-endpoints-service/loren-user-settings-endpoints.service';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class LorenUserSettingsService {
    private http = inject(HttpClient);
    private endpoints = inject(LorenUserSettingsEndpointsService);


    getUserNotificationsSubscriptions(userId: number) {
        return this.http.get<GenericItems<number>>(this.endpoints.userNotificationsSubscriptions(userId), {});
    }

    saveUserNotificationsSubscriptions(userId: number, subscribedAssets: number[]) {
        return this.http.post<GenericItems<number>>(this.endpoints.userNotificationsSubscriptions(userId), {
            items: subscribedAssets
        });
    }
}
